import * as Sentry from "@sentry/react";

/**
 * Sentry에 예외를 캡처합니다.
 * localStorage에서 userId를 가져와 자동으로 태그에 추가합니다.
 *
 * @param error - 캡처할 에러 객체
 * @param context - 추가 컨텍스트 (tags, extra 등)
 */
export const captureException = (
  error: unknown,
  context?: {
    tags?: Record<string, string | number | boolean>;
    extra?: Record<string, unknown>;
  }
) => {
  try {
    const userStr = localStorage.getItem("user");
    const userId = userStr ? JSON.parse(userStr)?.userId : undefined;

    Sentry.captureException(error, {
      tags: {
        ...context?.tags,
        ...(userId && { userId: String(userId) }),
      },
      extra: context?.extra,
    });
  } catch (e) {
    // localStorage 접근 실패 등의 경우에도 에러는 캡처
    Sentry.captureException(error, context);
  }
};

/**
 * Sentry의 사용자 컨텍스트를 설정합니다.
 *
 * @param userId - 사용자 ID
 */
export const setSentryUser = (userId?: number) => {
  if (userId) {
    Sentry.setUser({ id: String(userId) });
  } else {
    Sentry.setUser(null);
  }
};
